import type { QueryClient } from '@tanstack/react-query'
import type { OpportunityListResponse } from 'backend/types'
import { queryKeys } from '@/lib/queryKeys'

/**
 * オポチュニティ一覧のキャッシュ（全タブ）にある指定オポチュニティを更新する
 *
 * @param queryClient - QueryClient インスタンス
 * @param opportunityId - 更新対象のオポチュニティID
 * @param updater - 更新関数（既存のオポチュニティオブジェクトを受け取り、上書きする項目だけを返す）
 */
export function updateOpportunityListCache(
  queryClient: QueryClient,
  opportunityId: number,
  updater: (
    opp: OpportunityListResponse['opportunities'][number],
  ) => Partial<OpportunityListResponse['opportunities'][number]>,
) {
  queryClient.setQueriesData<OpportunityListResponse>({ queryKey: queryKeys.opportunities.all() }, (oldData) => {
    if (!oldData) return oldData

    return {
      ...oldData,
      opportunities: oldData.opportunities.map((opp) => (opp.id === opportunityId ? { ...opp, ...updater(opp) } : opp)),
    }
  })
}
